// Port of api/fuel/app/classes/filter/search/games/sorts/query/play/date/last.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'

function getActiveName(filter) {
	if (sorted('played.last', filter) > 0) return 'played.last'
	if (sorted('played.last.all', filter) > 0) return 'played.last.all'
	if (sorted('played.last.context', filter) > 0) return 'played.last.context'
	return null
}

export default {
	name: 'played.last.*',
	post: false,
	require: function(config, filter) { return getActiveName(filter) !== null },
	run: function(config, filter, data, query) {
		var name = getActiveName(filter)
		query.leftjoin('p')
		query.order('MAX(p.play_date)', sortReverse(name, filter), sortPriority(name, filter))
	}
}
